import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompareEmptyState = () => {
  const history = useHistory();
  const backToPricingClick = () => {
    history.push('/marketing');
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "empty-state-charts",
      width: 150
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "compare.requestStatus.UNINITIALIZED.title"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "compare.requestStatus.UNINITIALIZED.description"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: backToPricingClick,
      className: "m-top-8",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "compare.page.backToPricing"
      })
    })]
  });
};
export default CompareEmptyState;